<template>
  <div id="user-billing" class="layout-padding">
    <h5><q-icon name="attach_money" color="primary" /> Billing </h5>
    <div class="row">
      
      <h6 class="q-pa-md">Payment Methods</h6>
      <div class="col-12 q-pa-md" v-if="paymentProfiles.length == 0">
        No payment profiles found.
      </div>
      <div class="col-12 q-pa-md" v-if="paymentProfiles.length > 0">
        <q-list separator highlight class="round">
          <q-item class="" v-for="(paymentProfile,i) in paymentProfiles" :key="i">
            <q-item-main>
              <q-icon name="credit_card" /> {{paymentProfile.label}}
            </q-item-main>
            <q-item-side right>
              <q-btn @click.native="deleteProfileMethod(paymentProfile)" icon="fa fa-trash-o" color="red" flat />
            </q-item-side>
          </q-item>
        </q-list>
      </div>
      <div class="col-12 q-pa-md meta" v-if="user.CUSTOMER_ID">
        Customer ID: {{user.CUSTOMER_ID}}
      </div>
    </div>
    <q-inner-loading :visible="loading">
      <q-spinner-puff color="primary" size="70"></q-spinner-puff>
      <span>Loading..</span>
    </q-inner-loading>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import { required, requiredUnless, minLength, maxLength, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'UserRoles',
  components: { 
  },
  props: {
    validation: Object
  },
  created () {
    let vm = this
    vm.retrieveCustomerPaymentMethods({ USER_ID: vm.user.USER_ID })
  },
  data () {
    return {
      module: this.$route.meta.module
    }
  },
  computed: {
    ...mapState('users', {
      user: s => s.userForm,
      paymentProfiles: s => s.billingForm.paymentProfiles,
      loading: s => s.billingForm.loading
    })
  },
  methods: {
    ...mapActions('users', [
      'retrieveCustomerPaymentMethods',
      'deleteCustomerPaymentProfile'
    ]),
    deleteProfileMethod({ label, value, cascadesProfileId }){
      let vm = this
      vm.$q.dialog({
        title: 'Remove Payment Method?',
        message: `${label}`,
        ok: {
          label: 'Remove',
          color: 'negative'
        },
        cancel: {
          label: 'Cancel',
          color: 'grey'
        }
      })
        .then(async () => {
          await vm.deleteCustomerPaymentProfile({
            customerProfileId: vm.user.CUSTOMER_ID,
            customerPaymentProfileId: value,
            cascadesProfileId
          })
          await vm.retrieveCustomerPaymentMethods({ USER_ID: vm.user.USER_ID })
        })
      
    }
  }
}
</script>

<style lang="stylus">
  #user-billing
    position relative
    h6
      margin-top 50px
    .q-list
      padding 0
    .meta
      color #999
      font-size 14px
</style>
